<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="scope !== null">

    <div class="p-grid p-mb-4">
      <div class="p-col-6">
        <h2>{{ t('common.labels.procedures') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
        <button [withRight]="editRight" *ngIf="loading !== true" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div *ngIf="hasEmptyEntries()" role="alert" class="p-messages p-component p-mb-4">
      <div role="alert" class="p-message p-message-warn">
        <div class="p-message-wrapper">
          <span class="p-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
          <span class="p-message-detail">{{ t('common.messages.empty_dimension_no_access') }}</span>
        </div>
      </div>
    </div>

    <app-loader [loading]="loading"></app-loader>

    <ng-container *ngIf="loading !== true">

      <p-table
        styleClass="p-datatable-sm"
        [value]="templates"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="data-scope-templates-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >

        <ng-template pTemplate="colgroup">
          <colgroup>
              <col>
              <col style="width:90px">
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
              <th>{{ t('common.labels.procedure') }}</th>
              <th>{{ t('common.labels.enabled') }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-template>
            <tr tabindex="0">
              <td [ngClass]="{inactive: template.control_enabled.value !== true}">{{ template.name }}</td>
              <td>
                <app-form-control [cid]="template.name + '_enabled'" [control]="template.control_enabled" [type]="'checkbox'" [edit]="inEdit" [basevalue]="template.control_enabled.value" [noMargin]="true" [showLabel]="false"></app-form-control>
              </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="2">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>

      <ng-container *ngIf="orphans.length > 0">
        <div role="alert" class="p-messages p-component p-mt-4 p-mb-4">
          <div role="alert" class="p-message p-message-warn">
            <div class="p-message-wrapper">
              <span class="p-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
              <span class="p-message-detail">{{ t('common.messages.orphan_entry_still_effective') }}</span>
            </div>
          </div>
        </div>
        <p-table
          styleClass="p-datatable-sm"
          [value]="orphans"
          [paginator]="false"
        >
          <ng-template pTemplate="colgroup">
            <colgroup>
                <col>
                <col style="width:90px">
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
                <th>{{ t('common.labels.procedure') }}</th>
                <th>{{ t('common.labels.enabled') }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-orphan>
              <tr>
                <td>{{ orphan.name }}</td>
                <td>
                  <input type="checkbox" checked disabled>
                </td>
              </tr>
          </ng-template>
        </p-table>
      </ng-container>

    </ng-container>

  </form>
</ng-container>
